import { render } from "./a-task-planned-time.vue?vue&type=template&id=5c6a17d5"
import script from "./a-task-planned-time.vue?vue&type=script&lang=js"
export * from "./a-task-planned-time.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__